<template>
	<el-carousel indicator-position="outside" :height="height" :interval="5000" v-show="showCarousel">
		<el-carousel-item class="carousel_item" v-for="(item,index) in image" :key="index">
			<el-image :src="item" fit="cover" :preview-src-list="image"></el-image>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
	export default {
		name: 'carousel',
		data() {
			return {
				image: [],
				showCarousel: false,
				screenWidth: 0,
				onresize: null,
				height: '400px'
			}
		},
		mounted() {
			//获取屏幕尺寸
			this.screenWidth = document.body.clientWidth
			this.onresize = window.onresize = () => {
				//屏幕尺寸变化
				return (() => {
					this.screenWidth = document.body.clientWidth
					this.changeClientWidth(this.screenWidth)
				})()
			}
		},
		watch: {
			screenWidth: function(n, o) {
				this.changeClientWidth(n)
			}
		},
		beforeDestroy() {
			this.onresize = null
		},
		methods: {
			changeClientWidth(n) {
				if (n > 800) {
					this.height = '400px'
				} else if (n > 700) {
					this.height = '300px'
				} else if (n > 650) {
					this.height = '250px'
				} else if (n > 500) {
					this.height = '200px'
				} else if (n > 400) {
					this.height = '150px'
				} else {
					this.height = '150px'
				}
			},
			showImage(image) {
				this.image = image
				setTimeout(() => {
					this.showCarousel = true
				}, 200)
			}
		},

	}
</script>
